export const formatStatus = (status) => {
    if (!status) return "";
    if (status === "pass_by_dso") return "Pass by DSO";
    if (status === "pass_by_admin_checker") return "Pass by Admin Checker";
    return status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

export const formatLable = (label) => {
    if (!label) return "";
    return label.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'initial':
            return 'purple';
        case 'reject':
            return 'red';
        case 'pass':
            return 'green';
        case 'ask_for_resubmit':
            return '#F2E34C';
        case 'ongoing':
            return 'grey';
        case 'pass_by_dso':
            return 'blue';
        case 'pass_by_admin_checker':
            return '#ff7a00';
        default:
            return 'black'; 
    }
};